import { defineTemplate } from '@/core/define';

export default defineTemplate({
    theme: () => import(/* webpackChunkName: "theme-template2" */ './theme.scss'),
    assets: require.context('./assets/images', true, /\.(png|jpe?g|gif|svg|webp)$/),
    exclude: ['luckyDraw', 'walletTransfer']
});
